"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorAttendingApiResponseSchema = exports.getDoctorAttendingApiEntitySchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const doctor_attending_1 = require("./doctor-attending");
exports.getDoctorAttendingApiEntitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
    attributes: zod_1.z.object({
        userId: zod_1.z.string().uuid().nullable().default(null),
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        phoneNumber: zod_1.z.string().nullable().default(null),
        orderRegistrationNumber: zod_1.z.string(),
        rhythm: zod_1.z.string().nullable().default(null),
        // Structured rhythm fields (SA = Sans Assistant, AA = Avec Assistant)
        onSiteSlotsWithoutAssistant: zod_1.z
            .number()
            .int()
            .min(0)
            .nullable()
            .default(null),
        remoteSlotsWithoutAssistant: zod_1.z
            .number()
            .int()
            .min(0)
            .nullable()
            .default(null),
        onSiteSlotsWithAssistant: zod_1.z.number().int().min(0).nullable().default(null),
        remoteSlotsWithAssistant: zod_1.z.number().int().min(0).nullable().default(null),
        rhythmNote: zod_1.z.string().nullable().default(null),
        doctolibId: zod_1.z.string().nullable().default(null),
        iban: zod_1.z.string().nullable().default(null),
        bic: zod_1.z.string().nullable().default(null),
        commissionRate: zod_1.z.coerce.number().nullable(),
        signatureUrl: zod_1.z.string().nullable().default(null),
        workSchedulesDateRef: zod_1.z.string().nullable(),
        workSchedules: doctor_attending_1.workSchedulesSchema,
        createdAt: zod_1.z.coerce.date(),
        activatedAt: zod_1.z.coerce.date().nullable(),
        deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
    }),
});
exports.getDoctorAttendingApiResponseSchema = zod_1.z.object({
    data: exports.getDoctorAttendingApiEntitySchema,
});
